/* eslint-disable no-console */

import {register} from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.')
    },
    registered() {
      console.log('Service worker registered.')
    },
    cached() {
      console.log('Content has been cached.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(registration) {
      console.log('New content is available; please refresh.')
      document.dispatchEvent(
          new CustomEvent('swUpdated', {detail: registration}
          )
      )

      console.log('New content available — auto updating...')

      // 1) به SW بگو سریع فعال شود
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }

    },
    offline() {
      console.log('No internet connection. App is offline.')
    },
    error(error) {
      console.error('Error during registration:', error)
    }
  })
}
